export default "__VITE_ASSET__Cy1dZq46__"